import { Button, FormLabel, Stack } from '@mui/material';

import PropTypes from 'prop-types';
import React from 'react';
import castArray from 'lodash/castArray';
import { makeStyles } from 'tss-react/mui';
import startCase from 'lodash/startCase';
import styles from './ValidationButtonGroup.styles';
import { translate } from '/b2b/common/helpers/i18n';

const useStyles = makeStyles()(styles);

const ValidationFormGroup = props => {
    const { disabled, label, options, value: selected, onChange, id = '', ...remain } = props;
    const { classes, cx } = useStyles();
    const checked = castArray(selected);

    return (
        <Stack direction="row" alignItems="center">
            {label ? (
                <FormLabel component="span" id={`${id}--label`} className={classes.label}>
                    {translate(label)}
                </FormLabel>
            ) : null}
            <Stack
                direction="row"
                spacing={1}
                role="group"
                aria-labelledby={label ? `${id}--label` : undefined}
                sx={{ ml: 'auto' }}
                {...remain}
            >
                {Object.entries(options).map(([val, option], index) => {
                    const {
                        label: optionRawLabel,
                        value: optionValue,
                        checked: optionChecked,
                        disabled: optionDisabled,
                        ...optionRest
                    } = option;
                    const optionLabel = translate(optionRawLabel || startCase(val));
                    const value = optionValue !== undefined ? optionValue : val;
                    const isChecked =
                        optionChecked !== undefined ? !!optionChecked : !!checked.includes(value);
                    const isDisabled = optionDisabled || disabled;
                    return (
                        <Button
                            {...optionRest}
                            className={cx(classes.pill, isChecked && classes.selected)}
                            key={index}
                            id={`${id}--${index}`}
                            type="button"
                            aria-pressed={isChecked}
                            disableElevation
                            disableRipple
                            onClick={() => onChange(value)}
                            disabled={isDisabled}
                        >
                            {optionLabel}
                        </Button>
                    );
                })}
            </Stack>
        </Stack>
    );
};

ValidationFormGroup.propTypes = {
    component: PropTypes.any,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    label: PropTypes.string,
    id: PropTypes.string,
    value: PropTypes.string,
    options: PropTypes.object,
    onChange: PropTypes.func,
};

export default ValidationFormGroup;
